import request from '@/utils/request'
import { apiUrl, getwayurl } from './config'

const BASE = apiUrl + '/rjhy-factor-selector/api/1'

type dataType = any

export default {
  /**
   * 首页 - 我的策略列表
   */
  getStrategyList(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/strategy/mylist',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 口令兑换
   */
  redeemWatchword(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/watchword',
      method: 'post',
      data: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 组合 - 一键回测
   */
  doTestCom(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/dotest/com',
      method: 'post',
      data: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 盈利曲线
   */
  getReturnDetail(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/strategy/returndetail',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 组合 - 预设参数
   */
  getComOptions(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/com/options',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },
  /**
   * 组合 - 选股因子或者选股范围
   */
  getFactors(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/stock/select/user/factors',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

   /**
   * 通过token获取用户信息
   */
  tokenLogin(token: string): Promise<any> {
    return request({
      url: `${getwayurl}/rjhy-user/api/1/user/jfztpc/token/login`,
      method: 'get',
      params: {token, serverId: 200},
      sign: true,
      loginSign: true,
    } as any)
  },

  /**
   * 回测记录列表
   */
  getBacktestHistory(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/dotest/history',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 我的消息列表
   */
  getMessageList(data?: dataType): Promise<any> {
    return request({
      url: `${getwayurl}/rjhy-message-base/api/1/message/gw/detail/list/new/v2`,
      method: 'post',
      data: data?.data,
      headers: {
        'Content-Type': 'application/json',
        ...data?.headers
      },
      sign: true,
      newSign: true
    })
  },

  /**
   * 首页框架是否在期
   */
  homeCheck(data?: dataType): Promise<any> {
    return request({
      url: apiUrl + '/star-service/api/1/star/home/check',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

  /**
   * 智能选股平台-获取因子下选项列表
   * @param data.factorCode 因子编号（必填）
   * @returns data[].factorCode 因子编号
   * @returns data[].optionCode 选项编号
   * @returns data[].optionName 选项名称
   * @returns data[].optionDescription 选项描述
   * @returns data[].optionWeight 选项权重
   */
  getStockFactorOptions(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/stock/select/factor/options',
      method: 'get',
      params: data?.data,
      headers: data?.headers,
      sign: true,
      newSign: true
    })
  },

}

